<template>
    <div :class="{'wrapper no-icon-wrapper': noIcon, 'wrapper': !noIcon, disabled}">
        <div v-if="!inputLess" ref="current-container" style="display: inline-block;width: 100%;" @click="open" >
            <input cy-input="date-time-picker" type="text" ref="input" disabled :class="'input ' + inputClass" :value="inputValue"/>
            <div v-if="!inputValue" class="placeholder">{{placeholder}}</div>
            <div v-if="disabled && disabledText" class="disabled-text">{{disabledText}}</div>
        </div>
        <div v-if="opened" class="widget-wrapper" ref="widget-wrapper" :style="widgetContainerPosition" v-on-clickaway="close">
            <div v-if="pick === 'year'" class="month-year-wrapper" >
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-auto year-page-toggle" @click="yearPageStartYear -= 9">
                            <div class="arrow left-arrow"></div>
                        </div>
                        <div class="col d-flex align-items-center justify-content-center">
                            <div class="text-center font-weight-bold text-sm">{{$t('year')}}</div>
                        </div>
                        <div class="col-auto year-page-toggle" @click="yearPageStartYear += 9">
                            <div class="arrow right-arrow"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4 year-month-item no-text-selectable" v-for="y in years" :class="{active: currentYear == y}" :key="y" @click="setNewYear(y)">{{y}}</div>
                    </div>
                </div>
            </div>

            <div v-if="pick === 'month'" class="month-year-wrapper" >
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12"><div class="text-center font-weight-bold text-sm mb-2">{{$t('month')}}</div></div>
                    </div>
                    <div class="row">
                        <div class="col-4 year-month-item no-text-selectable text-sm" v-for="(m, i) in months" :class="{active: currentMonth == i + 1}" :key="m" @click="setNewMonth(i)">{{$t('month.' + (i + 1) + 'm')}}</div>
                    </div>
                </div>
            </div>

            <div v-if="pick === 'date'" class="month-table-wrapper" :style="monthTableWrapperStyle">
                <div class="monthly-view-header" :style="{background: this.themeColor}">
                    <div class="arrow left-arrow" @click.prevent.stop="prevMonth()"></div>
                    <div class="month-label" :style="{color: this.themedTextColor}" @click="pick = 'year'">
                        <span class="year">{{datesToDisplay[2][0].moment.format('YYYY')}}</span>
                        <span class="month">{{datesToDisplay[2][0].moment.format('MMMM')}}</span>
                    </div>
                    <div class="arrow right-arrow" @click.prevent.stop="nextMonth()"></div>
                </div>
                <table class="month-table">
                    <tr>
                        <th v-for="(weekday, index) in weekdays">{{weekday}}</th>
                    </tr>
                    <tr v-for="row in datesToDisplay">
                        <td v-for="date in row" cy-date-picker-date-item :class="{disabled: date.disabled || (isDateDisabled && isDateDisabled(date)), selected: isSelectedDate(date)}" style="position: relative;">
                            <div class="date-item-wrapper" :data-date="date.moment.format('M-D')" @click.prevent.stop="selectDate(date)">
                                <span class="date-item-content">{{date.moment.format('D')}}</span>
                                <div class="highlighted-background" :style="{background: themeColor}"></div>
                            </div>
                        </td>
                    </tr>
                </table>
                <div v-if="grayOutHint" class="text-muted text-center"><small>{{ grayOutHint }}</small></div>
            <loading-indicator
                :full-parent="true"
                :is-loading="showLoadingMask">
            </loading-indicator>
            <div v-if="timezoneHint" class="text-right text-muted"><small>{{timezoneHint}}</small></div>
            </div>
            <div v-if="showTimeViewWrapper" class="time-view-wrapper">
                <ul class="time-items">
                    <li class="time-item" cy-date-picker-time-item :key="time" v-for="time in timesForDate(selectedDate)" @click.prevent.stop="selectTime(time)" :style="{border: '1px solid ' + themeColor}" @mouseenter.capture="hoveredTime = time" @mouseout.capture="hoveredTime = null">
                        <div class="time-item-background" :style="{background: themeColor}"></div>
                        <div class="time-item-content"  :style="{color: ((hoveredTime == time) ? themedTextColor : '#444')}">{{time}}</div>
                    </li>
                </ul>
            <loading-indicator
                :full-parent="true"
                :is-loading="showLoadingMask">
            </loading-indicator>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import loadingIndicator from '../common/LoadingIndicator';
import {directive as onClickaway} from 'vue-clickaway';

export default {
    directives: {
        onClickaway: onClickaway,
    },
    components: {loadingIndicator},
    props: {
        inputLess: {
            type: Boolean,
            default: false
        },
        lang: {
            type: String,
            default: 'zh'
        },
        themeColor: {
            type: String,
            require: false,
            default: '#8DD9FB'
        },
        noIcon: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            required: false
        },
        value: {
            type: String
        },
        fixedTime: {
            type: String,
            required: false
        },
        timesForDate: {
            type: Function,
            required: true
        },
        closeOnSelect: {
            type: Boolean,
            required: false,
            default: true
        },
        isDateDisabled: {
            type: Function,
            required: false
        },
        disabled: {
            type: Boolean
        },
        disabledText: {
            type: String
        },
        showDateTextOnly: {
            type: Boolean,
            default: false
        },
        inputClass: {
            type: String,
            required: false,
            default: ''
        },
        showLoadingMask: {
            type: Boolean,
            required: false,
            default: false
        },
        targetMoment: {
            type: Object,
            required: false
        },
        timezoneHint: {
            type: String,
            required: false
        },
        grayOutHint: {
            type: String,
            required: false
        }
    },
    data() {
        var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        if (this.lang === 'zh') {
            moment.locale('zh-tw');
            weekdays = ['日', '一', '二', '三', '四', '五', '六'];
        }
        
        if (this.value) {
            var targetMoment = moment(this.value);
        } else if (this.targetMoment) {
            var targetMoment = this.targetMoment;
        } else {
            var targetMoment = moment();
        }

        const months = [];
        for (var i = 0 ; i < 12 ; i++) {
            months.push(i + 1);
        }

        const datesToDisplay = this.dates(targetMoment.toDate().getFullYear(), targetMoment.toDate().getMonth());
        if (this.inputLess) {
            this.$nextTick(() => {
                this.opened = true;
            })
        }
        return {
            opened: false,
            weekdays,
            today: targetMoment.toDate(),
            datesToDisplay,
            widgetContainerPosition: {},
            hoveredTime: null,
            monthTableWrapperStyle: {},
            selectedDate: this.value ? targetMoment : null,
            selectedTime: this.fixedTime,
            containerEl: null,
            pick: 'date', // date, month, year
            months,
            newYearToSet: null,
            yearPageStartYear:  (new Date()).getFullYear(),
            yearsPerPage: 9
        }
    },
    watch: {
        opened() {
            if (this.opened) {
                this.$nextTick(() => {
                    this.containerEl = this.$refs['widget-wrapper'];
                    if (this.containerEl.parentElement && this.containerEl.parentElement.tagName !== 'BODY') {
                        this.containerEl.parentElement.removeChild(this.containerEl);
                    }
                    $('body').append(this.containerEl);
                    this.positionWidgetContainer();
                });
            } else {
                this.$emit('close');
            }
        },
        targetMoment() {
            if (!this.value && this.targetMoment) {
                this.datesToDisplay = this.dates(this.targetMoment.toDate().getFullYear(), this.targetMoment.toDate().getMonth());
            }
        },
        showTimeViewWrapper() {
            this.$nextTick(() => {
                this.positionWidgetContainer();
            });
        }
    },
    computed: {
        years() {
            const years = [];
            for (var i = 0 ; i < this.yearsPerPage ; i++) {
                years.push(this.yearPageStartYear + i);
            }
            return years;
        },
        currentYear() {
            if (this.selectedDate) {
                return this.selectedDate.year();
            }
            return this.today.getFullYear();
        },
        currentMonth() {
            if (this.selectedDate) {
                return this.selectedDate.month() + 1;
            }
            return this.today.getMonth() + 1;
        },
        showTimeViewWrapper() {
            return this.pick === 'date' && !this.fixedTime && this.opened && this.selectedDate && this.timesForDate(this.selectedDate).length > 0
        },
        themedTextColor() {
            var colors = _.chunk(this.themeColor.substring(1), 2);
            var r = parseInt(colors[0][0] + "" + colors[0][1], 16);
            var g = parseInt(colors[1][0] + "" + colors[1][1], 16);
            var b = parseInt(colors[2][0] + "" + colors[2][1], 16);
            var Y = 0.2126*r + 0.7151*g + 0.0721*b;
            return Y >= 140 ? '#333' : 'white';
        },
        displayRangeStart() {
            return this.datesToDisplay[0][0].moment;
        },
        displayRangeEnd() {
            return this.datesToDisplay[this.datesToDisplay.length - 1][this.datesToDisplay[this.datesToDisplay.length - 1].length - 1].moment;
        },
        inputValue() {
            if (!this.value) {
                return '';
            }
            let format = 'YYYY-MM-DD A h:mm';
            if (this.showDateTextOnly) {
                format = 'YYYY-MM-DD';
            }
            return moment(this.value).format(format);
        }
    },
    mounted() {
        window.addEventListener('scroll', this.positionWidgetContainer, true);
    },
    destroyed() {
        window.removeEventListener('scroll', this.positionWidgetContainer, true);
        if (this.containerEl && this.containerEl.parentElement) {
            this.containerEl.parentElement.removeChild(this.containerEl);
        }
    },
    methods: {
        setNewYear(y) {
            this.newYearToSet = y;
            this.pick = 'month';
        },
        setNewMonth(m) {
            this.datesToDisplay = this.dates(this.newYearToSet, m);
            this.newYearToSet = null;
            this.pick = 'date';
            this.$emit('range-change', this.currentRange());
        },
        positionWidgetContainer() {
            // input less mode
            if(this.inputLess) {
                this.widgetContainerPosition = {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'fixed',
                    top: 0, right: 0, bottom: 0, left: 0
                };
                this.monthTableWrapperStyle = {'align-self': 'auto'};
                return;
            }

            if (!this.$refs['current-container'] && !this.$refs['widget-wrapper']) {
                return
            }

            const marginY = 2;
            const widgetWrapperHeight = 250;
            var currentContainerOffset = this.$refs['current-container'].getBoundingClientRect();
            var $currentContainer = $(this.$refs['current-container']);
            const $widgetWrapper = $(this.$refs['widget-wrapper']);

            const canShowOnBottom = (currentContainerOffset.top + $currentContainer.outerHeight() + widgetWrapperHeight + marginY) <= window.innerHeight;
            const canShowOnTop = (currentContainerOffset.top - marginY - widgetWrapperHeight) > 0;

            const pxRightPartClipped = (currentContainerOffset.left + $widgetWrapper.outerWidth()) - document.documentElement.clientWidth + 16;
            
            if (pxRightPartClipped > 0) {
                var left = currentContainerOffset.left - pxRightPartClipped;
            } else {
                var left = currentContainerOffset.left;
            }

            if (canShowOnBottom) {
                // show on bottom
                this.widgetContainerPosition = {
                    top: (currentContainerOffset.top + $currentContainer.outerHeight() + 2) + 'px',
                    left: left + 'px',
                    minWidth: $currentContainer.outerWidth() + 'px'
                };
            } else if (canShowOnTop) {
                // show on top
                var bottomPx = window.innerHeight - currentContainerOffset.top + 2;
                this.widgetContainerPosition = {
                    bottom: (bottomPx) + 'px',
                    left: left + 'px',
                    minWidth: $currentContainer.outerWidth() + 'px'
                };
            } else {
                this.widgetContainerPosition = {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'fixed',
                    top: 0, right: 0, bottom: 0, left: 0
                };
                this.monthTableWrapperStyle = {'align-self': 'auto'};
            }
        },
        open() {
            if (this.disabled) {
                return;
            }
            this.opened = true;
            this.$emit('open');
        },
        close() {
            this.opened = false;
        },
        selectDate(date) {
            if (date.disabled || (this.isDateDisabled && this.isDateDisabled(date))) {
                return;
            }

            this.selectedDate = date.moment;

            const format = 'YYYY-MM-DD HH:mm:00';
            if (this.fixedTime) {
                this.opened = !this.closeOnSelect;
                var components = this.fixedTime.split(':');
                const newDate = moment(this.selectedDate).hour(components[0]).minute(components[1]);
                this.$emit('input', newDate.format(format));
            } else {
                this.selectedTime = null;
                this.$emit('input', null);
            }
        },
        selectTime(time) {
            this.selectedTime = time;

            var components = time.split(':');
            const format = 'YYYY-MM-DD HH:mm:00';
            const newDate = moment(this.selectedDate).hour(components[0]).minute(components[1]);
            this.$emit('input', newDate.format(format));
            this.opened = !this.closeOnSelect;
            this.hoveredTime = null;
        },
        isSelectedDate(date) {
            if (!this.selectedDate) {
                return false;
            }
            const selectedMoment = moment(this.selectedDate);

            return date.moment.year() === selectedMoment.year()
            && date.moment.month() === selectedMoment.month()
            && date.moment.date() === selectedMoment.date();
        },
        prevMonth() {
            var prev = this.datesToDisplay[2][0].moment.subtract(1, 'month');
            this.datesToDisplay = this.dates(prev.year(), prev.month());
            this.$emit('range-change', this.currentRange());
        },
        nextMonth() {
            var next = this.datesToDisplay[2][0].moment.add(1, 'month');
            this.datesToDisplay = this.dates(next.year(), next.month());
            this.$emit('range-change', this.currentRange());
        },
        currentRange() {
            return {
                start: this.displayRangeStart,
                end: this.displayRangeEnd
            };
        },
        dates(year, month) {
            var first = moment().year(year).month(month).date(1).startOf('day');
            var dates = [{moment: first, disabled: false}];
            while(true) {
                var next = dates[dates.length - 1].moment.clone().add(1, 'day');
                if (next.month() !== month) {
                    break;
                }
                dates.push({moment: next, disabled: false});
            }

            // fill up previous month date if necessary
            while (true) {
                var firstDate = dates[0];
                if (firstDate.moment.day() === 0) {
                    break;
                }
                dates.unshift({
                    moment: firstDate.moment.clone().subtract(1, 'day'),
                    disabled: false
                });
            }

            // fill up next month date if necessary
            while (true) {
                var lastDate = dates[dates.length - 1];
                dates.push({
                    moment: lastDate.moment.clone().add(1, 'day'),
                    disabled: false
                });
                if (lastDate.moment.day() === 6) {
                    break;
                }
            }

            var result = [];
            for (var i = 0 ; i < dates.length - 1 ; i++) {
                let week = Math.floor(i / 7);
                if (!result[week]) {
                    result[week] = [];
                }
                result[week].push(dates[i]);
            }

            return result;
        }
    }
}
</script>

<style scoped lang="scss">
.wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
    cursor: pointer;
}

.disabled-text {

}

.placeholder {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #31393C
}

.disabled .placeholder {
    color: #8E9FA7 !important;
}

input {
    background: #F4F8F9;
    border-radius: 4px;
    font-size: 1rem;
    color: #31393C;
    padding: 0.375rem 1.2rem;
    border: none;
    min-width: 200px;
    width: 100%;
    cursor: pointer !important;
    pointer-events:none;
}

.wrapper:hover {
    input {
        background: #e3edf0;
    }
}

.wrapper.disabled {
    cursor: not-allowed;
}

.wrapper::after {
    display: block;
    content: '';
    width: 15px;
    height: 12px;
    background: center / contain no-repeat url('/img/ic_calendar@2x.png');
    position: absolute;
    pointer-events: none;
    position: absolute;
    top: calc(50% - 7.5px);
    right: 12px;
}

@media screen and (max-width: 1023px) {
    .wrapper::after {
        display: none;
    }
}

.no-icon-wrapper::after {
    display: none;
}

.widget-wrapper {
    display: flex;
    position: fixed;
    z-index: 2147483647;
}

.monthly-view-header {
    display: flex;
    text-align: center;
    color: white;
    margin: -8px -8px 0px;
    align-items: center;
    padding-top: 4px;
    padding-bottom: 4px;
    font-size: 12px;
}

.arrow {
    flex-grow: 0;
    width: 24px;
    height: 24px;
    background-size: 8px;
    background-position: center;
    background-repeat: no-repeat;
    margin: 4px 4px;
    border-radius: 12px;
}

.arrow:hover {
    background-color: rgba(255, 255, 255, 0.5);
}

.left-arrow {
    background-image: url('/img/arrow_left@2x.png');
}
.right-arrow {
    background-image: url('/img/arrow_right@2x.png');
}

.month-label {
    text-align: center;
    color: #30353C;
    flex-grow: 1;

    cursor: pointer;
    &:hover {
        background: #ededed;
        border-radius: 4px;
        color:  #30353C !important;
    }
}

.month-table-wrapper {
    padding: 8px;
    background: white;
    display: inline-block;
    align-self: flex-start;
    width: 225px;
    box-shadow: 0 1px 3px 0 rgba(48,50,70,0.20);
    border-radius: 3px;
    margin-top: 4px;
    overflow: hidden;
    position: relative;
}

.month-year-wrapper {
    padding: 8px;
    background: white;
    display: inline-block;
    align-self: flex-start;
    width: 300px;
    box-shadow: 0 1px 3px 0 rgba(48,50,70,0.20);
    border-radius: 3px;
    margin-top: 4px;
    overflow: hidden;
    position: relative;
}

.month-table th {
    width: 30px;
    height: 30px;
    font-size: 12px;
    text-align: center;
    color: #30353C;
    opacity: 0.5;
}
.month-table td {
    width: 30px;
    height: 30px;
    font-size: 12px;
    text-align: center;
    color: #30353C;
    user-select: none;
}

.month-table td.disabled {
    opacity: 0.24;
}

.date-item-wrapper {
    cursor: pointer;
    justify-content: center;
    align-items: center;
}

.disabled .date-item-wrapper {
    cursor: auto;
}

.highlighted-background {
    display: none;
}

.selected .date-item-wrapper .highlighted-background, .date-item-wrapper:hover .highlighted-background {
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    top: 0;
    right: 0;
    z-index: 0;
    opacity: 0.5;
}

.date-item-content {
    z-index: 1000;
    position: relative;
    display: inline-block;
    color: #30353C;
}

.disabled .date-item-wrapper:hover::before {
    display: none;
}

.time-items {
    list-style: none;
    padding: 8px 16px;
    background: white;
    max-height: 228px;
    min-height: 120px;
    overflow-y: auto;
    box-shadow: 0 1px 3px 0 rgba(48,50,70,0.20);
    z-index: 1000;
}

.time-item {
    position: relative;
    padding: 4px 30px;
    font-size: 12px;
    border-radius: 3px;
    cursor: pointer;
    margin: 8px auto;
    word-break: keep-all;
}

.time-item-content { position: relative; }

.time-item.active, .time-item:hover {
    .time-item-background {
        display: block;
    }
}

.time-item-background {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
}

.time-view-wrapper {
    z-index: 1000;
    margin-top: 4px;
    position: relative;
    margin-left: 8px;
}

@media (max-width: 320px) {
    .widget-wrapper {
        flex-direction: column;
    }

    .time-items {
        display: flex;
        height: auto;
        width: 225px;
        overflow-x: scroll;
        margin-left: 0;
        min-height: 0;
        padding: 12px 24px;
    }

    .time-item {
        margin: 0px 4px;
    }
}

.year-month-item {
    text-align: center;
    border: 1px solid transparent;
    cursor: pointer;

    &:hover, &.active {
        background: #f2f2f2;
        border: 1px solid #ededed;
        border-radius: 4px;;
    }
}

.year-page-toggle {
    .left-arrow {
        background-image: url('/img/arrow_left@2x.png');
        filter: brightness(1) invert(1);
    }
    .right-arrow {
        background-image: url('/img/arrow_right@2x.png');
        filter: brightness(1) invert(1);
    }
}
</style>

<i18n>
{
    "en": {
        "year": "Year",
        "month": "Month"

    },
    "zh": {
        "year": "年",
        "month": "月"
    }
}
</i18n>
